import http from '../../utils/fetch';
import updownfile from "../../utils/updownfile";

export default {
    baseurl: '/api/swyl/v1/demo/secondOrderMain',

    //二级经销商审批
    secondLevelShpsaveOrSubmit(params) {
        return http({
            url: '/api/swyl/v1/dingdmain/secondLevelShpsaveOrSubmit',
            method: 'post',
            data: params
        });
    },

    //二级经销商订单查看
    selectSecondOrderById(id,taskid) {
        return http({
            url: '/api/swyl/v1/demo/secondOrderMain/selectById',
            method: 'post',
            params: {id,taskid}
        });
    },
    //二级经销商附件审批
    shpSubmitFujian(params) {
        return http({
            url: '/api/swyl/v1/demo/secondOrderMain/shpSubmitFujian',
            method: 'post',
            data: params
        });
    },
    //二级经销商附件审批查看
    selectSecondFjById(id,taskid) {
        return http({
            url: '/api/swyl/v1/demo/secondOrderMain/selectSecondFjById',
            method: 'post',
            params: {id,taskid}
        });
    },

    //分页查询二级订单
    selectSecondDingdanPage(query) {
        return http({
            url: '/api/swyl/v1/demo/secondOrderMain/selectPage',
            method: 'post',
            params: query
        });
    },
    toXiaoshouSystem(data,sendGoodsNumber) {
        return http({
            url: '/api/swyl/v1/demo/secondOrderMain/toXiaoshouSystem?sendGoodsNumber=' + sendGoodsNumber,
            method: 'post',
            data
        });
    },
    //删除二级订单
    deleteSecondOrder(id, deleteReason) {
        return http({
            url: '/api/swyl/v1/demo/secondOrderMain/deleteSecondOrder',
            method: 'post',
            params: {id, deleteReason}
        });
    },

    //撤回订单
    sapCHOrder(id, deleteReason, type,status) {
        return http({
            url: this.baseurl + '/withdrawSecondOrder',
            method: 'post',
            params: {id, deleteReason, type,status}
        });
    },

    //二级经销商上传订单附件
    submitFujian(ids) {
        return http({
            url: this.baseurl + '/submitFujian',
            method: 'post',
            params: {ids}
        });
    },
    confirmSendAll (sapCodes) {
        return http.post('/api/swyl/v1/dingdmainsend/confirmSendHh', sapCodes);
    },

}

